<template>

	<div class="footer">
		<div class="foot_content">
			<div class="foot-company">
				<div class="foot-logo"><span slot="label"><img class="logo" src="../../assets/images/logo.png" /><i
							class="newfan">{{siteName}}</i><i class="at">@</i><i class="pinpai">品牌森林</i></span></div>
				<ul class="foot-link">
					<li><img src="../../assets/images/phone.png" alt="电话"> <span id="csPhone">联系电话：15920567412</span>
					</li>
					<li class="fm-email"><img src="../../assets/images/mail.png" alt="邮箱">
						<span>联系邮箱：994233303@qq.com</span>
					</li>
				</ul>
				<div class="qrcode">
					<div>售前客服微信</div>
					<img src="../../assets/images/wangshaohong_qrcode.png">
				</div>
			</div>
			<div class="foot-border"></div>
			
			<!--

			--->
			<div class="foot-bottom" id="footer-bot">
				<span class="copyright-content">COPYRIGHT © 2024 {{companyName}}</span> 
				<a target="_blank" href="https://beian.miit.gov.cn"  class="gbeian1">{{beianText}}</a>
				<div v-if="recordcode != null" class="gbeian2">
		 			<a target="_blank" :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' + recordcode" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 {{recordcode}}号</p></a>
		 		</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				beianText: '',
				activeName: 'second',
				linkQrcodeVisable: false,
				companyName: '',
				siteName: '',
				recordcode: null
			};
		},
		mounted(){
			let url = location.href;
			if(url.indexOf('newfan')>0){
				this.companyName = '广州新帆网络科技有限公司版权所有'
				this.beianText = '粤ICP备2023007079号-1'
				this.siteName = '新帆玩具'
				this.recordcode = '44010602009676'
			}else if(url.indexOf('ilikeso')>0){
				this.companyName = '广州新帆网络科技有限公司版权所有'
				this.beianText = '粤ICP备2023007079号-3'
				this.siteName = '新帆玩具'
				this.recordcode = '44010602011295'
			}else if(url.indexOf('edu123')>0){
				this.companyName = '广州新帆网络科技有限公司版权所有'
				this.beianText = '粤ICP备2023007079号-2'
				this.siteName = '新帆玩具'
				this.recordcode = '44010602011260'
			}else if(url.indexOf('yunipk')>0){
				this.companyName = '广州新帆网络科技有限公司版权所有'
				this.beianText = '粤ICP备2023007079号'
				this.siteName = '新帆玩具'
			}else{
				this.companyName = '广州新帆网络科技有限公司版权所有'
				this.beianText = '粤ICP备2023007079号'
				this.siteName = '新帆玩具'
				this.recordcode = '44010602009676'
			}
		},
		
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			}
		}
	};
</script>

<style lang="scss">
	.footer {
		background-color: #181e2f;
		color: #a0a0a0;
		padding: 20px 260px;
		position: relative;

		.foot-company {
			overflow: hidden;

			.foot-logo {
				overflow: hidden;

				img {
					display: block;
					float: left;
					width: 50px;
					height: 42px;
					margin-top: 2px;
				}

				i {
					display: block;
					float: left;
					font-size: 28px;
					height: 42px;
					padding: 5px 2px;
				}
			}

			.foot-link {
				display: block;
				list-style-type: disc;
				margin-block-start: 0;
				margin-block-end: 0;
				margin-inline-start: 0px;
				margin-inline-end: 0px;
				padding-inline-start: 0px;
				padding: 20px 0 10px 0;

				img {
					width: 16px;
				}

				li {
					list-style: none;
					float: left;
					margin-right: 20px;
				}
			}
			
			.qrcode{
				position: absolute;
				top: 10px;
				right: 460px;
				width:100px ;
				height: 120px;
				text-align: center;
				div{
					padding-bottom: 8px;
					color: #f5f5f5;
				}
				img{
					width: 100px;
					height: 100px;
				}
			}
		}
		
		.foot-border{
			margin-top: 35px;
			border-bottom: solid 1px #333;
		}

		.foot-mid {
			overflow: hidden;
			width: 660px;
			margin: 30px auto;
			font-size: 14px;

			a {
				text-decoration: none;
				color: #a0a0a0;
				padding:  0 30px;

				&:hover {
					text-decoration: none;
					color: #a0a0a0;
				}
				&:link{
					text-decoration: none;
					color: #a0a0a0;
				}
			}
		}
		
		.foot-bottom{
			width: 1080px;
			margin: 0px auto 15px auto;
			font-size: 12px;
			a{
				padding: 0 5px 0 20px;
				text-decoration: none;
				&:hover {
					text-decoration: none;
					color: #a0a0a0;
				}
				&:link{
					text-decoration: none;
					color: #a0a0a0;
				}				
			}
			
			.gbeian1{
				color: #fff;
			}
			
			.gbeian2{
				width:300px;
				margin:0 auto; 
				padding:0px 10px;
				color: #fff;
				display: inline-block;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/footer/index.vue